import type { IconWrapperProps } from '@/core/components/icon/icon-wrapper';
import type { SVGIconProps } from '@/core/components/icon/svg-icon';

import { IconWrapper } from '@/core/components/icon/icon-wrapper';
import SVGIcon from '@/core/components/icon/svg-icon';

export default function PenIcon(props: SVGIconProps & IconWrapperProps) {
    return (
        <IconWrapper {...props}>
            <SVGIcon
                {...props}
                viewBox={'0 0 19 19'}
            >
                <path
                    d={
                        'M18.3 2.09 16.912.703A2.3 2.3 0 0 0 15.24 0a2.3 2.3 0 0 0-1.672.703l-2.773 2.755L9.504 4.75.708 13.547a.864.864 0 0 0-.247.532l-.456 3.933A.89.89 0 0 0 .88 19h.095l3.913-.437a.872.872 0 0 0 .532-.247L14.253 9.5l1.292-1.292 2.773-2.774c.912-.912.912-2.413-.019-3.344zM13 8.246l-8.587 8.588-2.508.266.285-2.508 8.587-8.588 1.804-1.805 2.223 2.223zm4.198-4.218L16.096 5.13a.058.058 0 0 1-.076 0l-2.166-2.147a.058.058 0 0 1 0-.076l1.102-1.102a.367.367 0 0 1 .532 0l1.71 1.71c.152.133.152.361 0 .513z'
                    }
                />
            </SVGIcon>
        </IconWrapper>
    );
}

export { PenIcon };
